import React from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';
import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';

export function ProviderNoNewPatients() {

    return (<>
        <ContentContainer className='flex-1 lg:flex-none text-center space-y-6'>
            <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
            <h1 className="text-2xl text-gray-900 font-medium">
                This provider is not accepting new patients.
            </h1>
            <p>
                Please contact the clinic directly or go back to select another provider.
            </p>

        </ContentContainer>
        <StickyBottomBar>
            <Button className="w-full"
                color="gray"
                onClick={() => window.close()} >
                Exit
            </Button>
        </StickyBottomBar>
    </>
    );
}